<template>
  <div class="elite-tabs-wrapper-content">
    <h3>
      {{ $objectDenomination(vehicle) }} -
      {{ $t("COMMON.LOGS") }}
    </h3>
    <ul>
      <li>{{ vehicle.odometer }} {{ vehicle.odometer_unit }}</li>
      <li class="line">|</li>
      <li><copy-element :element="vehicle.vin" /></li>
    </ul>
    <log-list-table :filterSubject="vehicle" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";
import CopyElement from "@/components/CopyElement.vue";

export default {
  name: "vehicle-view-logs",

  components: { LogListTable, CopyElement },

  props: ["vehicle"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
